import React from 'react';
import { withFirebase } from '../../firebase';

const SignOutButton = ({ firebase }) => (
  
    <h6 className=" text-warning mb-md-1" onClick={()=>{firebase.doSignOut(); window.location.href ="/"}}>Sign Out </h6>
 
);
 
export default withFirebase(SignOutButton);